import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LogCategory, LogCoreComponent, LoggerService, LogPage, LogType } from 'src/app/core/services/logger.service';
import { ProfileService } from '../../../core/services/profile.service';
import { ComponentData, ComponentMeta } from '../../../shared/component/component-meta';
import { Page } from '../../../shared/page/page';

@Component({
    selector: 'tile-modal',
    templateUrl: './tile-modal.component.html',
    styleUrls: ['./tile-modal.component.scss'],
    standalone: false
})

export class TileModalComponent {

    @Input() public componentName;
    @Input() public pageID;
    public widget: ComponentData;
    public isDataLoaded: boolean = false;

    constructor(
        private logger: LoggerService,
        public activeModal: NgbActiveModal,
        public profileService: ProfileService,
        private changeDetector: ChangeDetectorRef,
    ) {        
        this.log("constructor", null, LogCategory.Constructor);
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try("TileModalComponent" + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.Modal, category);
    }

    public onLoad(data: ComponentData) {
        this.log("onWidgetsLoaded", data.module);
        this.widget = data;
        this.isDataLoaded = true;
    }

    ngAfterViewInit() {
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4 
        this.changeDetector.detectChanges();
    }
}
